import { useTranslation } from "react-i18next";

import type { IApproveProps } from "./types";

import { Icon } from "@/components/atoms/icons";
import { Typography } from "@/components/atoms/typography";
import { Button } from "@/components/atoms/button";
import { showActionAlert } from "@/components/molecules/alert";
import { showAlert } from "@/stores/uiStore";
import type { ID } from "@constants";

const className = "flex-item-center gap-xs";

export function Approve(
  props: IApproveProps & { id: ID; isApproved?: boolean },
) {
  const { isLoading, onApprove, onReject, id, isApproved } = props;

  const { t } = useTranslation("actions");
  const { t: tAlert } = useTranslation("alerts");

  function approveHandler() {
    showAlert({ title: "title", type: "action" });
    showActionAlert({
      title: tAlert("approveArticle.title"),
      content: tAlert("approveArticle.approveContent"),
      approveTitle: t("approve"),
      onApprove: () => {
        onApprove?.(id);
      },
    });
  }

  function rejectHandler() {
    showActionAlert({
      title: tAlert("rejectArticle.title"),
      content: tAlert("rejectArticle.approveContent"),
      approveTitle: t("reject"),
      onApprove: () => {
        onReject?.(id);
      },
    });
  }

  return (
    <div className={"d-flex gap-xs"}>
      {(isApproved === undefined || isApproved === null) && (
        <>
          <Button mode={"action"} disabled={isLoading} onClick={rejectHandler}>
            <Typography
              color={isLoading ? "secondary-text" : "danger-main"}
              className={className}
            >
              <Icon name={"ForbiddenCircle"} />
              <span className={"color-inherit"}>{t("reject")}</span>
            </Typography>
          </Button>
          <Button mode={"action"} disabled={isLoading} onClick={approveHandler}>
            <Typography
              color={isLoading ? "secondary-text" : "success-main"}
              className={className}
            >
              <Icon name={"CheckCircle"} color={"inherit"} />
              <span className={"color-inherit"}>{t("acceptInformation")}</span>
            </Typography>
          </Button>
        </>
      )}
      {isApproved === true && (
        <Typography
          color={isLoading ? "secondary-text" : "success-main"}
          className={className}
        >
          <Icon name={"CheckCircle"} color={"inherit"} />
          <span className={"color-inherit"}>{t("accepted")}</span>
        </Typography>
      )}
      {isApproved === false && (
        <Typography
          color={isLoading ? "secondary-text" : "danger-main"}
          className={className}
        >
          <Icon name={"ForbiddenCircle"} />
          <span className={"color-inherit"}>{t("rejected")}</span>
        </Typography>
      )}
    </div>
  );
}
